export const PF = 'add-edit-inventory';
